import HocSinhShortInfo from "./HocSinhShortInfo";

export default HocSinhShortInfo